export const BRAND = {
  cream: "#FAF4E9", ivy: "#1E3A2B", ivySoft: "#2E5240", ivyDeep: "#132619",
  gold: "#C0953A", goldLight: "#DCBB6C", pink: "#E7AEB4", pinkDeep: "#C77E88", ink: "#21302A",
};

// Coach Nata's own branded artwork
export const NATA = {
  hero: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/j0h46ba5_5BE5E6F6-CC5A-4190-A9A2-217715410526.PNG",
  coach: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/w57sqs2z_EEC4262B-FA03-4EA4-9FCC-D3377D15B3C7.PNG",
  author: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/7k9x4ap5_CCC0363E-A6C9-4EF8-BE8B-FFAC6B4E1ABB.PNG",
  queen: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/m7lgls9q_8A8CDB64-4823-45B9-8E8B-8AEC37B5BAAB.PNG",
  portrait: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/mssbz5d6_BC3C41CB-3853-4EBC-8FE1-B1DAFC0F419C.png",
};

export const COVERS = {
  doppelgangers: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/mket7kwi_doppelganger%20cover%20soc%20media.png",
  resetProject: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/d1cf3zqf_CC396FBC-9FAD-424D-9148-4507B98D1A62.png",
  gamechanger: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/ei6lxcu0_66521D05-098E-418D-99B3-937D6CD0C375.png",
};

export const BRANDS = [
  { name: "Plan A Global", tag: "Parent Nonprofit", logo: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/qjot1bhb_New%20pag%20transLogo.png.png" },
  { name: "LiveFire Fellowship Church", tag: "The Church", logo: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/tas3d9os_LiveFire%20logo%202%20-%203.png" },
  { name: "Overflow Academy", tag: "Courses & Community", logo: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/51kx7fz0_overflow%20academy%20logo%20-%202.png" },
  { name: "Remnant United Network", tag: "The Recording Label", logo: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/5zfv8lxl_9178C7FE-551B-4157-8A85-EDDACE8DB40A.png" },
  { name: "Joy Reborn Publishing House", tag: "The Publishing House", logo: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/kjb0mlbq_Joy%20Reborn%20Publishing%20trans%20logo.png" },
];

export const WELCOME = {
  audio: "/audio/welcome.mp3",
  photo: "https://customer-assets.emergentagent.com/job_member-mastery/artifacts/mssbz5d6_BC3C41CB-3853-4EBC-8FE1-B1DAFC0F419C.png",
  text: "Welcome to Life With Nata. I don't believe you're here by accident. Every person has a purpose. Every purpose requires transformation. And every transformation begins with a decision. I'm Coach Nata — and I've dedicated my life to helping people become everything God created them to be. This isn't just a website. It's a movement — where broken dreams are rebuilt, leaders are equipped, and ordinary people step into extraordinary purpose. Here, faith meets strategy. Healing meets action. I don't just help people change their lives. I help them become the person Heaven already knows they are. This is a place to heal. To grow. To build. To lead. To reign. No matter where you've been, your story isn't over. So take a look around. And when you're ready… let's build a life that leaves a legacy. Come on in. Welcome home.",
};

export const IMAGES = {
  hero: NATA.hero,
  coach: NATA.coach,
  community: "https://images.pexels.com/photos/19049176/pexels-photo-19049176.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  read: NATA.author,
  listen: NATA.queen,
  speak: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  academy: NATA.coach,
};

export const STREAMS = [
  { id: "coach", label: "The Coach", tagline: "Coach · Leader · Builder", text: "I help women build Kingdom brands and legacies that last. Vision. Plan. Impact. Legacy.", image: NATA.coach, accent: "pink" },
  { id: "author", label: "The Author", tagline: "Writing Purpose · Publishing Truth", text: "From idea to finished manuscript — books that reset you, built on faith and strategy.", image: NATA.author, accent: "gold" },
  { id: "voice", label: "The Voice", tagline: "Pastor · Artist · Teacher", text: "Queen of Multiple Streams. One calling. Many assignments. Eternal impact.", image: NATA.queen, accent: "gold" },
];

export const PILLARS = [
  { n: "01", title: "Purpose", text: "King & Queen Builder — discovering who you're called to be." },
  { n: "02", title: "Wholeness", text: "Healing and deliverance for the wounded places." },
  { n: "03", title: "Connection", text: "Community, mentorship, and the resources to rise." },
  { n: "04", title: "Overflow", text: "Living so full that your life pours into others." },
];

export const WORLDS = [
  { n: "01", slug: "transform", verb: "Transform", title: "Coaching & Overflow Academy",
    blurb: "Assessments, courses, and group coaching that move you from wounded to whole." },
  { n: "02", slug: "read", verb: "Read", title: "Author & Books",
    blurb: "The Gamechanger, The Reset Project, Break the Box — and a 50+ book pipeline." },
  { n: "03", slug: "listen", verb: "Listen", title: "Music & Podcast",
    blurb: "The Reset Project album as Renatah Rae, plus the Back to Worship podcast." },
  { n: "04", slug: "belong", verb: "Belong", title: "Ministry · Plan A Global",
    blurb: "LiveFire Fellowship, Eagle's Nest Institute, and 5-fold commissioning." },
  { n: "05", slug: "invite", verb: "Invite", title: "Speaking & Teaching",
    blurb: "25+ years equipping rooms — keynotes, workshops, and training." },
];

export const PATHWAYS = [
  { id: "reset-experience", tag: "Signature Cohort", title: "The Reset Experience",
    desc: "A guided reset built on the R6 Method™ — Reveal, Reckon, Renounce, Receive, Reinforce, Release.", price: 497, badge: "Application-based",
    duration: "12 weeks · Cohort",
    ideal_for: "You're carrying old identity, invisible wounds, and cycles you can't seem to break — even though you love God, you love people, and you show up every day.",
    includes: [
      "Weekly live group sessions with Coach Nata",
      "The R6 Method™ workbook & digital toolkit",
      "Private cohort community (30-day support after)",
      "1× private breakthrough call",
      "Lifetime access to session recordings",
    ] },
  { id: "go-get-your-crown", tag: "Group Coaching", title: "Go Get Your Crown!",
    desc: "An 8-week journey to reclaim your identity and finish what you started.", price: 297, badge: "Cohorts forming",
    duration: "8 weeks · Group",
    ideal_for: "You know what's yours. You've said it out loud. You've started twice. Now it's time to actually finish — with structure, accountability, and someone who won't let you shrink.",
    includes: [
      "8 weekly live group coaching calls",
      "Crown Journal & weekly declarations",
      "Private group chat with Coach Nata",
      "Guided identity + purpose audits",
      "Certificate on completion",
    ] },
  { id: "birthing-room", tag: "1:1 Coaching", title: "The Birthing Room",
    desc: "Private coaching for visionaries ready to birth the thing they've been carrying.", price: 1200, badge: "Limited spots",
    duration: "6 months · Private",
    ideal_for: "You're carrying a mandate that is bigger than a program can handle. You need direct access, custom strategy, and someone who has done what you're about to do.",
    includes: [
      "12 private 60-min sessions with Coach Nata (bi-weekly)",
      "Voxer/text access between sessions",
      "Custom launch or ministry strategy blueprint",
      "Team review & operating rhythm setup",
      "One in-person or hybrid intensive (2 days)",
    ] },
  { id: "book-coaching", tag: "For Writers", title: "Book Coaching",
    desc: "From idea to finished manuscript — structure, voice, and accountability.", price: 850, badge: "By season",
    duration: "16 weeks · Private",
    ideal_for: "You have a book inside you and half a folder of Google Docs. You want to be published — traditionally or well — without losing your voice in the process.",
    includes: [
      "Book strategy & positioning session",
      "10 private editing / voice coaching calls",
      "Chapter-by-chapter developmental review",
      "Publishing-path guidance (traditional vs. indie)",
      "Launch runway plan (audience, endorsements, PR)",
    ] },
];

export const BOOKS = [
  { title: "Doppelgängers", tag: "On Amazon Now", desc: "The Becoming of Faith — kill the illusion, claim the crown, fulfill the call. A Christian fantasy novel.",
    cover: COVERS.doppelgangers,
    link: "https://www.amazon.com/Doppelg%C3%A4ngers-Becoming-Illusion-Crown-Fulfill-ebook/dp/B0FXMWXSKT?tag=5812456021-20" },
  { title: "The Reset Project", tag: "Bestseller · On Amazon", desc: "The 30-Day Bounce Back to a Better, NEVER You — with a companion worship album.",
    cover: COVERS.resetProject,
    link: "https://www.amazon.com/Reset-Project-30-Day-Bounce-Better-ebook/dp/B09C8XCJ4Q" },
  { title: "The Gamechanger", tag: "Available Now", desc: "Training for Reigning, Vol 1 — Awakening Identity, Authority & Kingdom Dominion.",
    cover: COVERS.gamechanger, link: "https://www.gamechangerbook.online", linkLabel: "Buy the Book", spotlight: true },
  { title: "Break the Box", tag: "Available Now", desc: "Don't just think outside the box… break it. A bold call to dismantle the limits that keep you playing small." },
  { title: "Kingdom Marriages", tag: "Manuscript", desc: "The biblical prototypes of covenant union." },
  { title: "Church Hurt", tag: "Coming Soon", desc: "And how to overcome it." },
];

export const MUSIC = [
  { title: "The Reset Project", tag: "2026 · New Album", desc: "The companion worship album to the devotional — a track for every step.", cover: COVERS.resetProject },
  { title: "The Broken Ones", tag: "2015 · Renatah Rae", desc: "A body of worship for the wounded and rebuilding." },
  { title: "Shades of Grey, Vol. I", tag: "2013 · Renatah Rae", desc: "Soul that ministers — early signature sound." },
];

export const MINISTRY = [
  { title: "LiveFire Fellowship", tag: "The Church", desc: "A community where the wounded heal and the called are commissioned." },
  { title: "Eagle's Nest Institute", tag: "The Institute", desc: "Training the next generation of leaders in 5-fold ministry." },
  { title: "5-Fold Commissioning", tag: "The Mandate", desc: "Apostolic equipping that identifies, develops, and releases leaders." },
  { title: "Plan A Global Ministries", tag: "Parent Nonprofit", desc: "The house that holds it all — the 'Save the Lights' mandate." },
];

export const TALKS = [
  { tag: "Keynote", title: "Life from the Overflow", desc: "Out of survival and into overflow." },
  { tag: "Worship", title: "Worshipping While Wounded", desc: "How to keep your praise when life has left you hurting." },
  { tag: "Mindset", title: "The CORE", desc: "Overcoming the barriers within for real, lasting success." },
  { tag: "Workshop", title: "The R6 Method™", desc: "Reveal, Reckon, Renounce, Receive, Reinforce, Release." },
];

export const STATS = [
  { v: "400+", l: "Keynotes & Presentations" },
  { v: "1200+", l: "Trained & Coached" },
  { v: "18+", l: "Years Educator & Coach" },
  { v: "100+", l: "Events & Conferences" },
];

export const TESTIMONIALS = [
  { quote: "Renata has such a warmth and ability to connect that it captures everybody. She has something for everyone!", name: "Christina Harris", role: "Certified Life Coach · TV & Radio Personality", photo: "https://images.pexels.com/photos/36439572/pexels-photo-36439572.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600" },
  { quote: "Renata's voice moves mountains. I left our session with clarity I'd been chasing for years.", name: "Linda Bowen", role: "Coach & Author", photo: "https://images.pexels.com/photos/30161439/pexels-photo-30161439.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600" },
  { quote: "I walked in wounded and walked out whole. The Reset Experience changed how I see my entire life.", name: "Tasha M.", role: "Reset Experience Graduate", photo: "https://images.pexels.com/photos/5352619/pexels-photo-5352619.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600" },
];
